"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'RiskDevice',
  bodyClass: 'risk-device-page',
  components: {},
  data: function data() {
    return {
      uriPortal: process.env.VUE_APP_BASE_URL_RISK_DEVICE_INCOGNIA
    };
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  }
};